"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A logger accepts messages from different levels
 * and emits them in a certain way.
 */
class Logger {
    /**
     * Convert a string-based logging level to a numerical logging level.
     * @param level A string-based logging level
     * @return The numerical logging level, or undefined.
     */
    static getLevelOrdinal(level) {
        return Logger.LEVELS[level];
    }
}
/**
 * All available logging levels.
 * @type {{trace: number; debug: number; info: number; warn: number; error: number; fatal: number}}
 */
// tslint:disable:object-literal-sort-keys
Logger.LEVELS = {
    trace: 0,
    debug: 1,
    info: 2,
    warn: 3,
    error: 4,
    fatal: 5,
};
exports.Logger = Logger;
/**
 * @type {string} Context entry for a logger instance.
 * @value {Logger} A logger.
 */
exports.KEY_CONTEXT_LOG = '@comunica/core:log';
//# sourceMappingURL=Logger.js.map